<template>
  <div class="md-flex">
    <div class="sidebar flex-none xs-hide sm-hide"></div>
    <div class="project-detail md-pl2">
      <div class="project-title black line-height-3 pt1 sm-pt0 md-right-align">
        <h1 v-html="title" class="regular line-height-3 mt0"></h1>
        <p class="h6" v-html="byline"></p>
      </div>
      <image-list :images="images" :post="post" class="m0"></image-list>
    </div>
  </div>
</template>

<script>
  import store from '@/store'
  import ImageList from '@/components/partials/ImageList'

  export default {
    name: 'project',
    computed: {
      post () {
        const { slug } = this.$route.params
        const { type } = this.$route.meta
        return this.$store.state[type].find(p => p.slug === slug)
      },
      title () {
        return this.post.title.rendered
      },
      images () {
        return this.post.acf && this.post.acf.gallery
      },
      byline () {
        return this.post.acf && this.post.acf.byline
      }
    },
    beforeRouteEnter (to, from, next) {
      const { slug } = to.params
      const { type } = to.meta
      store.dispatch('getProject', { type, slug }).then(() => {
        next()
      })
    },
    components: { ImageList }
  }
</script>



// WEBPACK FOOTER //
// src/components/Project.vue